"use strict";
/*
 * Created on 2. 6. 2020
 *
 * Copyright (c) 2020 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var moment = require("moment");

var DomainObject_1 = require("../../../core/model/DomainObject");
/**
 * Stored header of promotion performance report.
 * @author Radek Beran
 */


var PromotionPerformanceReportHeader =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PromotionPerformanceReportHeader, _DomainObject_1$Domai);

  /**
   * @param id
   * @param root
   * @param rootMapping
   * @param promotionIds
   * @param completed
   * @param error
   * @param filter
   */
  function PromotionPerformanceReportHeader(id, root, rootMapping, promotionIds, completed, error, filter) {
    var _this;

    _classCallCheck(this, PromotionPerformanceReportHeader);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromotionPerformanceReportHeader).call(this));
    _this.id = id;
    _this.root = root;
    _this.rootMapping = rootMapping;
    _this.promotionIds = promotionIds;
    _this.completed = completed;
    _this.error = error;
    _this.filter = filter;
    _this.created = moment();
    return _this;
  }
  /**
   * Returns node by given path of IDs.
   * @param path
   */


  _createClass(PromotionPerformanceReportHeader, [{
    key: "getNodeByPath",
    value: function getNodeByPath(path) {
      return this.getNodeByPathInternal(this.root, path);
    }
  }, {
    key: "getNodeByPathInternal",
    value: function getNodeByPathInternal(node, path) {
      var sub = path.shift();

      if (sub) {
        var child = node.children.find(function (ch) {
          return ch.id === sub;
        });

        if (child) {
          return this.getNodeByPathInternal(child, path);
        }

        return node;
      }

      return node;
    }
  }]);

  return PromotionPerformanceReportHeader;
}(DomainObject_1.DomainObject);

exports.PromotionPerformanceReportHeader = PromotionPerformanceReportHeader;
PromotionPerformanceReportHeader.DUMMY = new PromotionPerformanceReportHeader('', {
  id: '',
  parentId: null,
  children: [],
  level: 1
}, immutable_1.Map(), immutable_1.List(), false, null, {});